<template>
  <div class="dialog-wrap">
    <el-dialog
      :visible="visible"
      title="公告详情"
      class="dialog notice-dialog"
      :close-on-click-modal="false"
      width="900"
      @close="handleDialogClose"
    >
      <div>
        <h6 class="notice-title">{{ title }}</h6>
        <el-scrollbar class="notice-content m-t-16">
          <u-editor :value="content" disabled />
        </el-scrollbar>
      </div>
      <span slot="footer">
        <el-button
          type="primary"
          size="medium"
          @click="handleDialogClose"
        >我知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UEditor from '@/components/common/UEditor/index.vue'

export default {
  name: 'BulletinDialog',

  components: {
    UEditor
  },

  props: {
    visible: {
      type: Boolean,
      default: false
    },

    bulletinType: {
      type: String,
      default: ''
    },

    // 公告标题
    title: {
      type: String,
      default: ''
    },

    content: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      show: false,
      timer: null
    }
  },

  watch: {
    visible(newVal) {
      this.timer = setTimeout(() => {
        this.show = newVal
      }, 500)
    }
  },

  beforeDestroy() {
    clearTimeout(this.timer)
  },

  methods: {
    handleDialogClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-dialog {
  ::v-deep {
    .el-dialog {
      max-width: 1140px;
      min-width: 900px;
      width: 70%;
    }
    .el-dialog__body {
      overflow-y: auto;
      max-height: calc(100vh - 300px);
    }
  }
}
.notice-title {
  font-size: 20px;
  width: calc(100% - 140px);
  margin: 0 auto;
  text-align: center;
}
</style>
